import { createSingleEntityStore, ngrxEvent } from '@core/ngrx-legacy';
import { RECRUITEE_THEME_DEFAULT, RECRUITEE_THEME_LS_KEY } from '@core/theme-util';

import type { CurrentUserPreferencesRequestData } from './current-user-preferences.types';
import { EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<CurrentUserPreferencesRequestData>()(EntityStoreKey.userPreferences, {
    initialState: {
      data: {
        preferences: {
          theme: localStorage.getItem(RECRUITEE_THEME_LS_KEY) || RECRUITEE_THEME_DEFAULT,
          pipelinePromoteBannerDismissedOfferIds: [],
        },
      },
      loaded: false,
      pending: false,
      failed: false,
      error: null,
    },
    customActions: adapter => ({
      updatePreferredTheme: ngrxEvent<'light' | 'dark' | 'auto'>(),
      updatePipelinePromoteBannerDismissedOfferIds: ngrxEvent<number[]>(),
    }),
  });

export {
  actions as CurrentUserPreferencesActions,
  selectors as CurrentUserPreferencesSelectors,
  reducer as CurrentUserPreferencesReducer,
  namespace as CurrentUserPreferencesNamespace,
};
